import { Grid2 as Grid, TextField, Tooltip } from "@mui/material";
import React from "react";
import useDebugInformation from "../../../../hooks/useDebugInformation";
import useNato from "../../../../hooks/useNato";
import { useAppSelector } from "@store/hooks";
import { StringProcessor } from "@utils/stringProcessor";
import { MemoizedInputProps, a11yProps } from "../helpers";

const name = "Property";

const Property = React.memo<MemoizedInputProps>(({ parent, prefix, inputName, xs, sm, disabled, form }) => {
    const monitored = useAppSelector(({ ui }) => ui[`${prefix}${inputName}`]);
    const valid = useAppSelector(({ state }) => state[`${prefix}${inputName}Valid`]);

    const helperText = useAppSelector(({ ui }) => ui[`${prefix}${inputName}HelperText`]);

    const nato = useNato(inputName, monitored || "")

    useDebugInformation(`${parent}▷[${inputName}]`, { parent, inputName, prefix, xs, sm, sanitized: monitored, valid })
    return (
        (<Grid
            size={{
                xs,
                sm
            }}>
            <Tooltip title={nato} sx={{ maxWidth: "none" }} placement="right">
                <TextField disabled={disabled} value={monitored || ""} variant={monitored === "N/A" ? "filled" : "outlined"} required={!valid} {...a11yProps(inputName, prefix, form)} label={StringProcessor.camelToWords(inputName)} error={!valid} color={valid ? "primary" : "error"} helperText={!valid ? helperText : ""} />
            </Tooltip>
        </Grid>)
    );
})
Property.displayName = name;


export default Property;